module.exports = __webpack_public_path__ + "media/packs/images/flags/KZ-a80d8972730003e296ae2b344511648f.svg";